export interface SalesOrderProformaReportLineProcessing {
  processProductKey: string;
  processProductDescription: string;
}
